export default __webpack_public_path__ + "static/media/Sielanka_161.e5da9e76.jpg";